<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="600px" persistent>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon left>mdi-file-document-plus</v-icon>
        {{ editMode ? 'แก้ไข' : 'เพิ่ม' }}สัญญาจ้าง
      </v-card-title>
      
      <v-card-text class="pt-4">
        <v-form ref="contractForm" v-model="formValid">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="localData.start_date"
                label="วันที่เริ่มสัญญา"
                type="date"
                outlined
                :rules="[v => !!v || 'กรุณาระบุวันที่เริ่ม']"
              />
            </v-col>
            
            <v-col cols="12" md="6">
              <v-text-field
                v-model="localData.end_date"
                label="วันที่สิ้นสุดสัญญา"
                type="date"
                outlined
                :rules="[
                  v => !!v || 'กรุณาระบุวันที่สิ้นสุด',
                  v => !localData.start_date || v > localData.start_date || 'วันสิ้นสุดต้องหลังวันเริ่ม'
                ]"
              />
            </v-col>
            
            <v-col cols="12">
              <v-text-field
                v-model="localData.order_number"
                label="เลขที่คำสั่ง"
                outlined
                :rules="[v => !!v || 'กรุณาระบุเลขที่คำสั่ง']"
              />
            </v-col>
            
            <v-col cols="12">
              <v-textarea
                v-model="localData.note"
                label="หมายเหตุ (ไม่บังคับ)"
                outlined
                rows="3"
                counter="500"
                :rules="[v => !v || v.length <= 500 || 'หมายเหตุต้องไม่เกิน 500 ตัวอักษร']"
              />
            </v-col>
            
            <v-col cols="12">
              <v-file-input
                v-model="localData.file"
                label="ไฟล์สัญญาจ้าง (ไม่บังคับ)"
                accept=".pdf,.jpg,.jpeg,.png"
                outlined
                show-size
                prepend-icon="mdi-paperclip"
                :rules="fileRules"
              >
                <template v-slot:selection="{ text }">
                  <v-chip small label color="primary">
                    <v-icon left small>mdi-file</v-icon>
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
            </v-col>
          </v-row>
          
          <!-- แสดงระยะเวลาสัญญา -->
          <v-alert
            v-if="contractDuration"
            type="info"
            outlined
            dense
            class="mt-3"
          >
            <div class="font-weight-medium">ระยะเวลาสัญญา: {{ contractDuration }}</div>
          </v-alert>
        </v-form>
      </v-card-text>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('close')">ยกเลิก</v-btn>
        <v-btn 
          color="primary" 
          :loading="saving"
          :disabled="!formValid"
          @click="handleSave"
        >
          บันทึก
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ContractDialog',
  
  props: {
    value: Boolean,
    editMode: Boolean,
    data: Object,
    saving: Boolean
  },
  
  data() {
    return {
      localData: {},
      formValid: false,
      
      fileRules: [
        v => !v || v.size < 5000000 || 'ไฟล์ต้องมีขนาดไม่เกิน 5MB'
      ]
    }
  },
  
  computed: {
    contractDuration() {
      if (!this.localData.start_date || !this.localData.end_date) return null
      
      const start = new Date(this.localData.start_date)
      const end = new Date(this.localData.end_date)
      const diffTime = Math.abs(end - start)
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      const months = Math.floor(diffDays / 30)
      const days = diffDays % 30
      
      if (months > 0) {
        return `${months} เดือน ${days} วัน`
      }
      return `${diffDays} วัน`
    }
  },
  
  watch: {
    data: {
      handler(newData) {
        this.localData = { ...newData }
      },
      immediate: true,
      deep: true
    },
    
    value(newVal) {
      if (newVal) {
        this.localData = { ...this.data }
        this.$nextTick(() => {
          if (this.$refs.contractForm) {
            this.$refs.contractForm.resetValidation()
          }
        })
      }
    }
  },
  
  methods: {
    handleSave() {
      if (this.$refs.contractForm.validate()) {
        this.$emit('save', this.localData)
      }
    }
  }
}
</script>